<template>
  <div class="payment-details text-center">
    <box-header
      :navigation="true"
      url="/"
      :title="$t(`paymentselect.${pageDetails.paymentMethod}`)"
    ></box-header>
    <div class="row scroll">
      <div class="col-sm-12">
        <method-card v-if="pageDetails.paymentMethod === 'Card'"></method-card>
        <method-ideal
          v-if="pageDetails.paymentMethod === 'IDEAL'"
        ></method-ideal>
        <method-maestro
          v-if="pageDetails.paymentMethod === 'MAESTRO'"
        ></method-maestro>
        <method-bancontact
          v-if="pageDetails.paymentMethod === 'MISTERCASH'"
        ></method-bancontact>
        <method-wechat
          v-if="pageDetails.paymentMethod === 'WeChat'"
        ></method-wechat>
        <method-pos
          v-if="pageDetails.paymentMethod === 'POINT_OF_SALE'"
        ></method-pos>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");
import boxHeader from "@/components/box-header.vue";

const viewportWidth = Math.max(
  document.documentElement.clientWidth,
  window.innerWidth || 0
);

export default {
  name: "paymentMethodDetails",
  components: {
    boxHeader,
    methodCard: () =>
      import(/* webpackChunkName: "chunk-card" */ "./payment-methods/card.vue"),
    methodIdeal: () =>
      import(
        /* webpackChunkName: "chunk-ideal" */ "./payment-methods/ideal.vue"
      ),
    methodMaestro: () =>
      import(
        /* webpackChunkName: "chunk-maestro" */ "./payment-methods/maestro.vue"
      ),
    methodBancontact: () =>
      import(
        /* webpackChunkName: "chunk-bancontact" */ "./payment-methods/bancontact.vue"
      ),
    methodWechat: () =>
      import(
        /* webpackChunkName: "chunk-wechat" */ "./payment-methods/wechat.vue"
      ),
    methodPos: () =>
      import(/* webpackChunkName: "chunk-pos" */ "./payment-methods/pos.vue"),
  },
  computed: {
    ...paymentNS.mapGetters(["pageDetails"]),
  },
  mounted() {
    this.setOverlayBox(false);
    if (viewportWidth < 576) {
      document.querySelector(".payment-info").classList.add("small-box");
      document.querySelector(".scroll").classList.add("small-box");
    }
  },
  methods: {
    ...paymentNS.mapActions(["setOverlayBox"]),
  },
};
</script>
